import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store"; // 你的 store 文件路径
import API from "@/api";
import { useLocalStorage } from "@/util/Storage";
import { isEmpty } from "lodash";
import { loginByTelegramData, loginByWalletData } from "@/api/type";

export const postUserLoginByWallet = createAsyncThunk(
	"api/user/loginByWallet",
	async (params: loginByWalletData) => {
		try {
			const response = await API.members.userLoginByWallet(params);
			return response;
		} catch (error) {
			console.log(error);
		}
	}
);

export const postUserLoginByConsole = createAsyncThunk(
	"api/user/loginByConsole",
	async (params: loginByWalletData) => {
		try {
			const response = await API.members.userLoginByConsole(params);
			return response;
		} catch (error) {
			console.log(error);
		}
	}
);

export const postUserLoginByTelegram = createAsyncThunk(
	"api/user/loginByTelegram",
	async (params: loginByTelegramData) => {
		try {
			const response = await API.members.userLoginByTelegram(params);
			return response;
		} catch (error) {
			console.log(error);
		}
	}
);

export const postApiFinanceBalance = createAsyncThunk(
	"auth/postApiFinanceBalance",
	async (params: any, { getState }) => {
		try {
			// const state = getState() as any;
			const token = useLocalStorage.get("token");
			// uid: state.auth.userInfo.id,
			if (isEmpty(token)) return;
			const response = await API.finances.apiFinanceBalance(params);
			return response;
		} catch (error) {
			console.log(error);
		}
	}
);

export const getUserInfoMethod = createAsyncThunk(
	"auth/getUserInfoMethod",
	async (_, { getState }) => {
		try {
			const token = useLocalStorage.get("token");
			if (isEmpty(token)) return;
			const response = await API.members.getUserInfo({});
			return response;
		} catch (error) {
			console.log(error);
		}
	}
);

export const getApiFinancePayOrderItemMethod = createAsyncThunk(
	"auth/getApiFinancePayOrderItemMethod",
	async (params: any, { getState }) => {
		try {
			const { auth } = getState() as RootState;
			if (!auth.loginState) {
				return { code: 1001 };
			}
			// title: 0/已扣除,待审核 1/审核通过 -1/已退款(提现审核不过,已退款) -2/小额自动打款失败
			const response = await API.finances.apiFinancePayOrderItem(params);
			return response;
		} catch (error) {
			console.log(error);
		}
	}
);
//
export const getApiFinanceCashAddressMethod = createAsyncThunk(
	"auth/getApiFinanceCashAddressMethod",
	async (params: any, { getState }) => {
		try {
			const { auth } = getState() as RootState;
			if (!auth.loginState) {
				return { code: 1001 };
			}
			const response = await API.finances.apiFinanceCashOrderItem(params);
			return response;
		} catch (error) {
			console.log(error);
		}
	}
);

type UserInfo = {
	id: number;
	createTime: string;
	updateTime: string;
	uuid: string;
	nickname: string;
	walletAddress: string;
	devType: number;
	channelCode: string;
	inviteCode: string;
	registerIp: string;
	agentType: number;
	status: number;
	level: number;
	lastOnlineTime: string;
	setting: string;
	cover?: string;
	balance: Record<string, number>;
	income?: Record<any, any>;
	waterPlan?: Record<string, any>;
	inviteLevel: number; //当前邀请层级
	inviteUid: number; //邀请用户uid
	vaultUid: number; //金库uid
	scale: number;
	rolling: number; //此用户的分佣比例
};

interface AuthState {
	isAdminType: boolean;
	userInfo?: UserInfo | null;
	nativeUser?: {
		name: string;
		avatar?: string;
		is_master: boolean;
	} | null;
	tmpUserInfo?: UserInfo | null;
	balance: Record<string, number>;
	token: string;
	superiorToken?: string | null;
	loginState: boolean;
	dataPayOrder: any[];
	dataCashOrder: any[];
}

const initialState: AuthState = {
	isAdminType: false,
	userInfo: null,
	balance: {},
	token: "",
	loginState: false,
	dataPayOrder: [],
	dataCashOrder: [],
};

const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		setUserInfo: (state, action: PayloadAction<any>) => {
			state.userInfo = action.payload;
			state.loginState = true;
		},
		setNativeUser: (state, action: PayloadAction<any>) => {
			state.nativeUser = action.payload;
		},
		setToken: (state, action: PayloadAction<string>) => {
			state.token = action.payload;
			state.loginState = true;
			useLocalStorage.set("token", action.payload);
		},
		setSuperiorToken: (state, action: PayloadAction<string>) => {
			state.superiorToken = action.payload;
			useLocalStorage.set("superiorToken", action.payload);
		},
		setAdminType: (state, action: PayloadAction<boolean>) => {
			const adminType = action.payload;
			if (adminType && !state.isAdminType) {
				state.tmpUserInfo = state.userInfo;
			} else if (!adminType && state.isAdminType) {
				state.userInfo = state.tmpUserInfo;
				state.tmpUserInfo = null;
			}
			state.isAdminType = adminType;
			useLocalStorage.set("adminType", action.payload);
		},
		clearUserInfo: (state, action: PayloadAction) => {
			state.userInfo = null;
			state.tmpUserInfo = null;
			state.loginState = false;
			state.token = "";
			state.isAdminType = false;
			state.nativeUser = null;
			state.balance = {};
			state.dataPayOrder = [];
			state.dataCashOrder = [];
			useLocalStorage.remove("token");
			useLocalStorage.remove("superiorToken");
			useLocalStorage.remove("adminType");
		},
		clearState: (state, action: PayloadAction) => {
			return { ...initialState };
		},
	},
	extraReducers(builder) {
		builder.addCase(postApiFinanceBalance.pending, (state, action) => {
			console.log(
				"=================postApiFinanceBalance进行时==================="
			);
		});
		builder.addCase(postApiFinanceBalance.fulfilled, (state, action) => {
			try {
				const result = action.payload as any;
				if (result?.code === 0) {
					const content = result.content;
					const data = content.data;
					state.balance = data;
				}
			} catch (error) {
				console.log("---postApiFinanceBalance--:", error);
			}
		});
		builder.addCase(postApiFinanceBalance.rejected, (state, action) => {
			console.log(
				"=================postApiFinanceBalance出错了==================="
			);
		});

		builder.addCase(getUserInfoMethod.pending, (state, action) => {});
		builder.addCase(getUserInfoMethod.fulfilled, (state, action) => {
			try {
				const result = action.payload as any;
				if (result?.code === 0) {
					const content = result.content;
					const data = content.data;
					state.userInfo = data;
				}
			} catch (error) {
				console.log("---getUserInfoMethod--:", error);
			}
		});
		builder.addCase(getUserInfoMethod.rejected, (state, action) => {});

		builder.addCase(
			getApiFinancePayOrderItemMethod.pending,
			(state, action) => {
				console.log(
					"=================getApiFinancePayOrderItemMethod进行时==================="
				);
			}
		);
		builder.addCase(
			getApiFinancePayOrderItemMethod.fulfilled,
			(state, action) => {
				try {
					const result = action.payload as any;
					if (result?.code === 0) {
						const content = result.content;
						const data = content.data;
						state.dataPayOrder = data;
					}
				} catch (error) {
					console.log("---getApiFinancePayOrderItemMethod--:", error);
				}
			}
		);
		builder.addCase(
			getApiFinancePayOrderItemMethod.rejected,
			(state, action) => {
				console.log(
					"=================getApiFinancePayOrderItemMethod错误了==================="
				);
			}
		);

		builder.addCase(
			getApiFinanceCashAddressMethod.pending,
			(state, action) => {
				console.log(
					"=================getApiFinanceCashAddressMethod进行时==================="
				);
			}
		);
		builder.addCase(
			getApiFinanceCashAddressMethod.fulfilled,
			(state, action) => {
				try {
					const result = action.payload as any;
					if (result?.code === 0) {
						const content = result.content;
						const data = content.data;
						state.dataCashOrder = data;
					}
				} catch (error) {
					console.log("---getApiFinanceCashAddressMethod--:", error);
				}
			}
		);
		builder.addCase(
			getApiFinanceCashAddressMethod.rejected,
			(state, action) => {
				console.log(
					"=================getApiFinanceCashAddressMethod错误了==================="
				);
			}
		);
	},
});

export const userInfo = (state: RootState) => state.auth.userInfo;
export const {
	setUserInfo,
	setToken,
	clearUserInfo,
	clearState,
	setAdminType,
	setSuperiorToken,
	setNativeUser,
} = authSlice.actions;
export default authSlice.reducer;
/**
 * 
 * extraReducers: (builder) => {
		builder
			.addCase(postUserRegister.pending, (state) => {})
			.addCase(postUserRegister.fulfilled, (state, action) => {
				const resultData = action.payload as { data: any };
				const result = resultData.data;
			})
			.addCase(postUserRegister.rejected, (state, action) => {});
	},
*/
